import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { corporateCMSApi } from "~/Services";

interface DocumentDetailsResponse {
  id: number;
  image: string;
  title: string;
  field_homecards_title_ms: string;
  field_homecards_title_zh: string;
  field_homecards_desc_en: string;
  field_homecards_desc_ms: string;
  field_homecards_desc_zh: string;
  field_large_title_html_en: string;
  field_large_title_html_ms: string;
  field_home_large_html_zh: string;
  field_homecards_url_en: string;
  field_homecards_url_ms: string;
  field_homecards_url_zh: string;
  sequence: number;
  field_homecards_image: string;
  field_homecards_sequence: number;
  published: boolean;
  created_at: string;
  updated_at: string;
}

// edit api call
const fetchLargeCardsDetails = async (id: string): Promise<any> => {
  if (!id) {
    return null;
  }
  const response: any = await corporateCMSApi.get(`/api/get-homepage-large-cards-id/${id}`);
  return response.data[0];
};

const useLargeCardsDocumentDetails = (
  id: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  return useQuery<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>(
    {
      queryKey: ["largeCardsDocumentDetails", id],
      enabled: false,
      queryFn: () => {
        return fetchLargeCardsDetails(id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useLargeCardsDocumentDetails };
